import React from "react";
import PropTypes from "prop-types";
import css from "./table-class.module.scss";
import { useTheme } from "styled-components";
import getTableStyles from "themes/table-styles";
import DataTable from "react-data-table-component";
import {Link, withRouter} from "react-router-dom";
import { Button, OverlayTooltip } from "components";
import { IconDownload } from "Icons";
import * as util from 'services/util';
import { ButtonGroup, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as config from "config";
import { withLabelsContext, withUserContext } from "context";

function TableClass(props) {
  const theme = useTheme();
  const tableStyles = getTableStyles(theme);
  // tableStyles.table.style.borderRadius = "0 0 10px 10px";
  const columns = [
    {
      name: `${props.ctx_labels.singular.coursePublish}`,
      selector: row => row.course_publish_name,
      cell: (row) => {
        return (
          <OverlayTrigger overlay={<Tooltip>{row.course_publish_name}</Tooltip>}>
               <span>{row.course_publish_name.length >10 ? row.course_publish_name.slice(0,15)+"..." : row.course_publish_name}</span>
          </OverlayTrigger>
        );
      },
      sortable: true,
    }
    
    
    ,
    
    {
    name: `${props.ctx_labels.singular.course}`,
    selector: row => row.course_name,
    cell: (row) => {
      return (
        <OverlayTrigger overlay={<Tooltip>{row.course_name}</Tooltip>}>
          <span>{row.course_name.length >10 ? row.course_name.slice(0,15)+"..." : row.course_name}</span>
        </OverlayTrigger>
      );
    },
    sortable: true,
  },
    {
      name: `${props.ctx_labels.singular.trainer}`,
      selector: row => row.trainer_name,
      sortable: true,
    },
    {
      name: `${props.ctx_labels.singular.publish} ${props.ctx_labels.plural.from}`,
      selector: row => row.publishedFrom,
      sortable: true,
      sortFunction: (a,b) =>{
        return util.searchSorting(a.publishedFrom,b.publishedFrom)
      },

    },
    {
      name: `${props.ctx_labels.singular.publish} ${props.ctx_labels.plural.to}`,
      selector: row => row.publishedTo,
      sortable: true,
      sortFunction: (a,b) =>{
        return util.searchSorting(a.publishedTo,b.publishedTo)
      },

    },
    {
      name: `# ${props.ctx_labels.plural.trainee}`,
      selector: row => row.number_of_trainees,
      sortable: true,
    },
    {
      name: `% ${props.ctx_labels.singular.completionPercentage}`,
      selector: row => row.percentage_completion,
      sortable: true,
      cell: (row) => {
        return row.percentage_completion ? row.percentage_completion : "-"
      }
    },
    {
      name: `${props.ctx_labels.singular.avgScore} %`,
      selector: row => row.avg_test_percentage,
      sortable: true,
      cell: (row) => {
        return row.avg_test_percentage ? row.avg_test_percentage : "-"
      }
    },
    {
      name: props.ctx_labels.singular.link,
      selector: row => row.link,
      sortable: false,
      width: "85px",
      cell: (row) => {
          return(
              row.id !== null
                  ? (<Link onClick={
                          () => props.addRedirection()
                      }
                      to={
                          {
                              pathname: config.ROUTES.subjectProgress,
                              data: row,
                              className: props.location.data?.name || props.location.data?.className || props.data?.className,
                             interaction: props.data.interaction,
                             addRedirection: props.addRedirection,
                             classData:props.classData,
                             fromClassPerformance: props.isFromClassPerformance
                          }
                  }> {props.ctx_labels.singular.view}  </Link>)
                  : (<Link to="/" className="disabledCursor"
                      onClick={
                          (event) => event.preventDefault()
                  }>
                      {props.ctx_labels.singular.view}
                  </Link>)
          )
      }
  }, 
    {
      name: "",
      selector: row => row.actions,
      right: true,
      cell: (rowData) => (
        <>
        {props.ctx_user.user.reportsTrainer && 
          <Button
            iconOnly
            variant="white"
            size="sm"
            pill
            className="px-2 mr-3 ml-0"
            onClick={(e) => props.onDownloadClick(e, rowData)}
          >
            <IconDownload />
          </Button>
        }
        </>
      ),
    },
  ];

  return (
    <>
    { (props && props.ctx_user.user.type === 2) && 
      <div className={`${css.header}  text-color2`}>
        {props.data ? (
          <div className={css.title}>{props.data.className}</div>
        ) : (
          <TableClass />
        )}
        {/* <div className={css.header_status}>
          <div>
            <IconCircleCheckGreen />
            Correct
          </div>
          <div>
            <IconCircleCancelRed />
            Incorrect
          </div>
          <div>
            <IconCircleMinGray />
            Unattended
          </div>
        </div> */}
      </div>
      }

      {/* datatable */}
      <DataTable
        noHeader={true}
        columns={columns}
        data={props.data.interaction}
        customStyles={tableStyles}
        striped
        pagination
        fixedHeader
        fixedHeaderScrollHeight="650px"
      />
    </>
  );
}

TableClass.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
};

TableClass.defaultProps = {
  title: "",
  data: {},
};

export default withLabelsContext(withUserContext(withRouter(TableClass)));
